import {useMutation} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import Alert from "react-s-alert";
import {HubAndSpokeService} from "../../../services/HubAndSpokeService";

export const useEditEventTrigger = () => {
  const {eventTriggerId} = useParams<{eventTriggerId: string}>();
  const navigate = useNavigate();
  return useMutation(
    async (body: {
      document: string;
      facilities: Array<string>;
      template_field_id: string;
      sftp_config_id: string;
      document_path: string;
    }) => {
      const response = await HubAndSpokeService.editEventTrigger(
        eventTriggerId,
        body,
      );
      return response;
    },
    {
      onSuccess: () => {
        Alert.success("Event trigger successfully edited!");
        navigate("/admin/hub-and-spoke/event-triggers");
      },
      onError: (err: any) => {
        Alert.error(err?.data?.detail);
      },
    },
  );
};
